import { render, staticRenderFns } from "./RipaFormContainer.vue?vue&type=template&id=36ea094c"
import script from "./RipaFormContainer.vue?vue&type=script&lang=js"
export * from "./RipaFormContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports